import { Pipe, PipeTransform } from '@angular/core';
import dayjs, { OpUnitType } from 'dayjs';

@Pipe({
  name: 'dayjsStartOf',
  standalone: true
})
export class DayjsStartOfPipe implements PipeTransform {

  public transform(value: dayjs.Dayjs, unitOfTime: OpUnitType | 'isoWeek'): dayjs.Dayjs {
    return value.startOf(unitOfTime);
  }
}
